module.exports = __webpack_public_path__ + "img/status-photo-1.0b45fe2d.png";